export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'FirstName',
    'LastName',
    'RequestMessage',
    'Email'
  ],
  'requiredFields': {
    'default': [
      'Company',
      'PostalCode'
    ],
    'consulting': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'offersGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'customer_serviceGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'cooperation': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'other': [
      'PostalCode'
    ]
  },
}
